import styled from 'styled-components';
import { useState } from 'react';
import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { DCB_MODES } from '../constants';
import { ClauseBlock } from './ClauseBlock';
import { ElseIfContentList } from './ElseIfContentList';
import { DefaultClauseBlock } from './DefaultClauseBlock';
import { useTranslation } from '../hooks/useTranslation';
import { ConditionalContentContextProvider, ContentType } from '../contexts';
import { useConditionalContentController } from '../hooks/form';
import { ConditionalContentError } from './ConditionalContentError';
import { ConditionBuilderSegmentedControl } from './ConditionBuilderSegmentedControl';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing.values.threeQuarter};
`;

const Title = styled.span`
  ${({ theme }) => theme.styles.headings.heading4};
  font-size: 16px;
`;

export const ConditionBuilderContent = () => {
  const { t } = useTranslation();
  const {
    fieldState: { error },
  } = useConditionalContentController();

  const [mode, setMode] = useState<DCB_MODES>(DCB_MODES.ASSISTED);

  const isDynamicContentAssistEnabled = useFeatureFlag('DynamicContentAssist');

  const manualContent = (
    <>
      {!!error && <ConditionalContentError />}
      <Title>{t('contentTitle')}</Title>
      <ConditionalContentContextProvider type={ContentType.Conditional}>
        <ClauseBlock />
        <ElseIfContentList />
      </ConditionalContentContextProvider>
      <ConditionalContentContextProvider type={ContentType.Default}>
        <DefaultClauseBlock />
      </ConditionalContentContextProvider>
    </>
  );

  return (
    <Wrapper>
      {isDynamicContentAssistEnabled ? (
        <>
          <ConditionBuilderSegmentedControl mode={mode} setMode={setMode} />
          {mode === DCB_MODES.MANUAL ? manualContent : <div>temp assisted</div>}
        </>
      ) : (
        <>{manualContent}</>
      )}
    </Wrapper>
  );
};
